export default function IdentityBar() {
  return (
    <header
      className="relative w-full flex items-center"
      style={{ height: '8vh', minHeight: '56px' }}
      role="banner"
    >
      <div className="w-full h-full flex items-center px-4 md:px-[56px]">
        <div className="flex flex-col leading-none">
          <span
            className="text-[11px] md:text-xs font-thin uppercase tracking-[0.15em] text-foreground-800"
            style={{ fontFamily: 'var(--font-body)', fontWeight: 100 }}
          >
            Vasko
          </span>
          <span
            className="text-[11px] md:text-xs font-thin uppercase tracking-[0.15em] text-foreground-800 mt-[3px]"
            style={{ fontFamily: 'var(--font-body)', fontWeight: 100 }}
          >
            Solutions LLC
          </span>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-foreground-200/50" />
    </header>
  );
}